
import { Breadcrumb } from "antd"
import React from "react"
import { useState } from "react"
import AdjustmentsSearch from "./AdjustmentsSearch";
import AdjustmentInfo from "./AdjustmentInfo";
import AdjustmentSummary from "./AdjustmentSummary";
import useLookUpTables from "../../maintenance/complaints/useLookUpTables";
import { useEffect } from "react";
import { getBNVaults } from "../../../networking/NetworkingOrders";
import { getBNAdjustment } from "../../../networking/NetworkingBNAdjustment";
import { GlobalSystemParametersNames } from "../../../../src/constants/GlobalSystemParametersNames";
import dayjs from "dayjs";

const  AdjustmentsScreen = () => {

    const [step,setStep] = useState(1);
    const lookUpTables = useLookUpTables('BN Reference Type,BN Adjustement Type');
    const [vaultList, setVaultList] = useState([]);
    const [buyCurrency, setBuyCurrency] = useState(localStorage.getItem('BNBase Currency'));
    const [buyCurrencyScale, setBuyCurrencyScale] = useState(2);
    const [buyCurrencySymbol, setBuyCurrencySymbol] = useState('');
    const [buyCurrencyName, setBuyCurrencyName] = useState('');
    const [currencies, setCurrencies] = useState([]);
    const [reload, setReload] = useState(false);
    const baseCCy= localStorage.getItem('BNBase Currency');
    const [objAdjustment, setObjAdjustment] = useState({
            AdjustmentID:'',
            VaultID: -1,
            VaultName: '',
            ReferenceType: '',
            ReferenceID: '',
            ReferenceDate: new Date().toLocaleDateString('en-US'), 
            AccountingDate: new Date().toLocaleDateString('en-US'), 
            CurrencyID:baseCCy,
            TotalAdjustment: 0,
            AdjustmentRows: []
        });
    const blankAdjustment ={
            AdjustmentID:'',
            VaultID: -1,
            VaultName: '',
            ReferenceType: '',
            ReferenceID: '',
            ReferenceDate: new Date().toLocaleDateString('en-US'), 
            AccountingDate: new Date().toLocaleDateString('en-US'), 
            CurrencyID:baseCCy,
            TotalAdjustment: 0,
            AdjustmentRows: []
        }

        
        useEffect(()=>{
                const loadVaults = async () => {

        
                    const json = await getBNVaults();
        
                    if(json !== undefined && json.data) {
                        const vaults = json.data.map((c) => ({...c, value: c.VaultID, name: c.Description}));
                        vaults.splice(0,0,{value: -1, name: "Select a vault"});
                        setVaultList(vaults);                
                    }
                    
                    let currenciesList = JSON.parse(localStorage.getItem('Currencies'));
                                if(currenciesList !== undefined) {
                                    currenciesList = currenciesList.map((c) => ({...c, value: c["Currency Id"], name: `${c["Currency Id"]} - ${c["Currency Name"]}`}));
                                    setCurrencies(currenciesList);
                                }           
                }
                loadVaults();
            },[])

    useEffect(()=>{
        const currencies = JSON.parse(localStorage.getItem('Currencies'));
        if(currencies)
        {
            const ccy = currencies.find(c=> c["Currency Id"] === buyCurrency)
            if(ccy)
            {
                setBuyCurrencyScale(ccy.Scale);
                setBuyCurrencySymbol(ccy.Symbol);
                setBuyCurrencyName(`${ccy["Currency Id"]} - ${ccy["Currency Name"]}`);
            }
        }
    },[buyCurrency])

        const getBreadcrumb = () =>{
            let breadcrumb = [];
             switch (step) {
                        case 1:
                        default:
                            breadcrumb.push(<Breadcrumb.Item key="bd-order" className="breadcrumb-item-bold" onClick={() => setStep(1)}>{`Adjustments`}</Breadcrumb.Item>)   
                            break;
                        case 2:
                            breadcrumb.push(<Breadcrumb.Item key="bd-order" className="breadcrumb-item-bold" onClick={() => setStep(1)}>{`Adjustments`}</Breadcrumb.Item>)   
                            breadcrumb.push(
                                            <Breadcrumb.Item key="bd-order" className="breadcrumb-item-bold" onClick={() => setStep(2)}>{objAdjustment.AdjustmentID && objAdjustment.AdjustmentID !== '' ? 'Edit Adjustment':'New Adjustement'}</Breadcrumb.Item>
                                        );
                            break;
                    }
            return breadcrumb;
    }    

    const backToSearchScreen = ()=>{
      setStep(1);
    }

    const updateBuyCurrencyValue =(value)=>{
        setBuyCurrency(value);
    }

    const cleanOrder = () =>{
        setObjAdjustment(blankAdjustment);
      }

    const cancelAdjustment = (obj)=>{
      cleanOrder();
      setStep(1);
    }

    const newAdjustment = () =>{
      let obj_adj=blankAdjustment;
      let str_bnSystemDate=localStorage.getItem(GlobalSystemParametersNames.BNSystemDate);
      let bnSystemDate = dayjs(str_bnSystemDate, "YYYY-MM-DD").toDate();
      obj_adj.ReferenceDate=bnSystemDate;
      obj_adj.AccountingDate=bnSystemDate;
      setObjAdjustment(obj_adj);
      setStep(2);
    }

    const backScreen = (obj)=>{
      setObjAdjustment(obj);
      setStep(2);
    }

    const updateOrderRowCostRate = (objAdjustment) =>{

      setObjAdjustment(objAdjustment);
      setReload(!reload);
    }

    const getAdjustmentUpdated = async(adjustmentID) =>{
        const responseAdjustment = await getBNAdjustment(adjustmentID);
        if(responseAdjustment)
        {
            if(responseAdjustment && responseAdjustment.AdjustmentID && responseAdjustment.AdjustmentID  !== '')
            {
                responseAdjustment.validations = {
                    VaultID: true,
                    ReferenceDate: true,
                    ReferenceType: true,
                    CurrencyID: true
                }
    
                responseAdjustment.AdjustmentRows.forEach((row,index) =>{
                    row.key = index;
                    row.validations={
                        CurrencyID: true,
                        ProfitLoss: true,
                        Amount: true,
                        CostRate: true,
                        BuyAmount: true
                    }  
                })
                responseAdjustment.CanEdit = 0;
                setObjAdjustment(responseAdjustment);
                
            }
            setStep(3);
        }
    }

    const handleAdjustmentSelected = async(responseAdjustment) =>{
        if(responseAdjustment && responseAdjustment.AdjustmentID && responseAdjustment.AdjustmentID !== '')
        {
            responseAdjustment.validations = {
                    VaultID: true,
                    ReferenceDate: true,
                    ReferenceType: true,
                    CurrencyID: true
            }

            responseAdjustment.AdjustmentRows.forEach((row,index) =>{
                    row.key = index;
                    row.validations={
                        CurrencyID: true,
                        ProfitLoss: true,
                        Amount: true,
                        CostRate: true,
                        BuyAmount: true
                    }  
            })

            setObjAdjustment(responseAdjustment);

            if(responseAdjustment.CanEdit)
            {
                setStep(2);
            }
            else
            {
                setStep(3);
            }
        }
    }
        

  const getStepScreen = () =>{
        let screen = <></>;
         switch (step) {
                    case 1:
                    default:
                        screen = (<AdjustmentsSearch addAdjustment={newAdjustment} vaultList={vaultList} referenceTypeList={lookUpTables.BNReferenceType} onAdjustmentSelected={handleAdjustmentSelected} />);         
                        break;
                    case 2: 
                        screen = <AdjustmentInfo objAdjustment={objAdjustment} buyScale={buyCurrencyScale} lockedSide={'Buy'} currenciesList={currencies} updateAdjustment={(obj) => setObjAdjustment(obj)} changeScreen={()=> setStep(3)}
                        referenceTypeList={lookUpTables.BNReferenceType} buyCcy={buyCurrency} vaultList={vaultList} updateBuyCurrencyValue={updateBuyCurrencyValue} 
                        backToSearchScreen={backToSearchScreen} adjustmentTypeList={lookUpTables.BNAdjustementType}/>
                        break;
                    case 3:
                        screen= <AdjustmentSummary objAdjustment={objAdjustment} buyScale={buyCurrencyScale} backScreen={backScreen} cancelAdjustment={cancelAdjustment}
                                    baseCurrencySymbol={buyCurrencySymbol} baseCurrencyName={buyCurrencyName}  newAdjustment={newAdjustment} updateOrderRowCostRate={updateOrderRowCostRate} reload={reload} getAdjustmentUpdated={getAdjustmentUpdated}/>
                        break;
                    }
        return screen;
    }

    return (<>
        <div className="breadcrumb-div">
            <Breadcrumb separator=">">
                {getBreadcrumb()}
            </Breadcrumb>
        </div>
        {getStepScreen()}
        
    </>)

}
export default AdjustmentsScreen